import { toRaw } from 'vue';

/*
    Update the URL when the filters change
*/
function updateUrlFromParams(
    params,
    categoriesStore,
) {

    const url = new URL(document.location);
    const pathname = url.pathname;
    const urlParams = new URLSearchParams();

    const chosen = categoriesStore.chosenTopLevelCategory;

    if (chosen) {

        urlParams.set('topLevelCategory', chosen);

    };

    for (const key in params) {

        const value = params[key];

        // if the param is an object
        if (
            typeof value === 'object' &&
            !Array.isArray(value) &&
            value !== null
        ) {

            urlParams.set(key, JSON.stringify(value));

        // if the param is an array
        } else if (
            Array.isArray(value)
        ) {

            if (value.length > 0) {

                urlParams.set(key, value);

            }

        // if the param has a value, and is not limit or seed
        } else if (
            value &&
            key !== 'limit' &&
            key !== 'seed'
        ) {

            urlParams.set(key, value);

        }

    }

    if (urlParams.toString() !== '') {
        window.history.replaceState({}, '', pathname + '?' + urlParams);
    } else {
        window.history.replaceState({}, '', pathname);
    }

}

/*
    Update the filters on page load, if there are params in the URL
*/
function getParamsFromUrl(){

    const url = new URL(document.location);
    const urlSearchParams = new URLSearchParams(url.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    return params;

}

/*
    set initial values for:
        1. keywords
        2. startDate
        3. endDate
        4. bounds
        5. offset
*/
async function setInitialParamValues(paramsFromUrl, queryParams) {

    if (paramsFromUrl['keywords']) {
        queryParams.updateParamString('keywords', paramsFromUrl['keywords']);
    };

    if (paramsFromUrl['startDate']) {
        queryParams.updateParamString('startDate', paramsFromUrl['startDate']);
    };

    if (paramsFromUrl['endDate']) {
        queryParams.updateParamString('endDate', paramsFromUrl['endDate']);
    };

    if (paramsFromUrl['bounds']) {

        const boundsObj = JSON.parse(paramsFromUrl['bounds']);

        queryParams.updateParamString('bounds', {
            "northEast": {
                "latitude": boundsObj.northEast.latitude,
                "longitude": boundsObj.northEast.longitude
            },
            "southWest": {
                "latitude": boundsObj.southWest.latitude,
                "longitude":boundsObj.southWest.longitude
            }
        });

    };

    if (paramsFromUrl['offset']) {
        queryParams.updateParamString('offset', parseInt(paramsFromUrl['offset']));
    };

}

export const routing = {

    updateUrlFromParams,
    getParamsFromUrl,
    setInitialParamValues,

};
